import { render, staticRenderFns } from "./addStore.vue?vue&type=template&id=3666f936"
import script from "./addStore.vue?vue&type=script&lang=js"
export * from "./addStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports